<template>
  <transition name="modal">
    <div v-if="showModal" class="modal-mask" @click="(e) => emit('close', e)">
      <div class="modal-wrapper">
        <div class="modal-container" @click.stop>
          <div class="modal-header">
            <slot name="header" />
          </div>
          <div class="modal-body">
            <slot name="body" />
          </div>
          <div class="modal-footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script setup>
const props = defineProps({
  showModal: Boolean
})
const emit = defineEmits(['close'])
</script>
<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 32, 63, 0.7);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  position: absolute;
  display: flex;
  max-height: 90%;
  width: 100%;
  max-width: 600px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.modal-container {
  position: relative;
  width: fit-content;
  width: 100%;
  margin: 0px auto;
  overflow-y: scroll;
  padding: 1rem;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;

  @include mobileLandscape {
    padding: 2.5rem;
  }
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  transform: scale(1.1);
}
</style>
